export default __webpack_public_path__ + "static/media/logo1.4d2642b9.png";